import type {
  SupportAiSettingsCreateApiData,
  SupportAiSettingsCreateApiResponses,
  SupportAiSettingsGetApiData,
  SupportAiSettingsGetApiResponses,
  SupportAiSettingsListApiData,
  SupportAiSettingsListApiResponses,
  SupportAiSettingsPatchApiData,
  SupportAiSettingsPatchApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getSupportAiSettingsUrls = {
  getPaginatedSupportAiSettings: dataEndpoint<SupportAiSettingsListApiData, SupportAiSettingsListApiResponses>({
    getUrl: (queryParams) => apiUrl('support-ai-settings/', queryParams)
  }),
  getSupportAiSettings: dataEndpoint<SupportAiSettingsGetApiData, SupportAiSettingsGetApiResponses>({
    getUrl: ({ supportAiSettingsId }) => apiUrl(`support-ai-settings/${supportAiSettingsId}/`)
  }),
  postSupportAiSettings: responseEndpoint<SupportAiSettingsCreateApiData, SupportAiSettingsCreateApiResponses>({
    getUrl: () => apiUrl('support-ai-settings/'),
    getBody: (body) => body
  }),
  patchSupportAiSettings: responseEndpoint<SupportAiSettingsPatchApiData, SupportAiSettingsPatchApiResponses>({
    getUrl: ({ supportAiSettingsId }) => apiUrl(`support-ai-settings/${supportAiSettingsId}/`),
    getBody: ({ supportAiSettingsId: _, ...body }) => body
  })
};
